import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Attention Surplus Hyperactivity Order",
  date: new Date(2025, 2, 30),
  img: "/img/portland.jpeg",
  tracks: [
    {
      title: "Quick Start Guide",
      src: "/songs/2025-03-30/quick_start_guide.mp3",
      duration: 311.736,
    },
    {
      title: "Sunday Night Fever",
      src: "/songs/2025-03-30/sunday_night_fever.mp3",
      duration: 612.48,
    },
    {
      title: "Preamble Pie",
      src: "/songs/2025-03-30/preamble_pie.mp3",
      duration: 320.736,
    },
    {
      title: "Weekend Getaway",
      src: "/songs/2025-03-30/weekend_getaway.mp3",
      duration: 766.296,
    },
    {
      title: "Waiting For You",
      src: "/songs/2025-03-30/waiting_for_you.mp3",
      duration: 713.04,
    },
    {
      title: "Casual Sunday",
      src: "/songs/2025-03-30/casual_sunday.mp3",
      duration: 618.072,
    },
    {
      title: "Just Another Dope-Ass Tune",
      src: "/songs/2025-03-30/jadat.mp3",
      duration: 501.96,
    },
    {
      title: "Late Night Dinner Party",
      src: "/songs/2025-03-30/late_night_dinner_party.mp3",
      duration: 638.76,
    },
    {
      title: "Shakin' In My Boots",
      src: "/songs/2025-03-30/shakin_in_my_boots.mp3",
      duration: 607.44,
    },
    {
      title: "Foot-Stompin' Fun",
      src: "/songs/2025-03-30/foot_stompin_fun.mp3",
      duration: 438.384,
    },
    {
      title: "All The Spaces",
      src: "/songs/2025-03-30/all_the_spaces.mp3",
      duration: 663.816,
    },
    {
      title: "Multiple Personalities",
      src: "/songs/2025-03-30/multiple_personalities.mp3",
      duration: 633.12,
    },
    {
      title: "Awe And Wonderland",
      src: "/songs/2025-03-30/awe_and_wonderland.mp3",
      duration: 942.336,
    },
    {
      title: "Collage College",
      src: "/songs/2025-03-30/collage_college.mp3",
      duration: 565.824,
    },
    {
      title: "The Seoul Of Portland",
      src: "/songs/2025-03-30/the_seoul_of_portland.mp3",
      duration: 690.048,
    },
    {
      title: "Fever Dream",
      src: "/songs/2025-03-30/fever_dream.mp3",
      duration: 2176.824,
    },
    {
      title: "Escaping Our Own Ignorance",
      src: "/songs/2025-03-30/escaping_our_own_ignorance.mp3",
      duration: 2183.184,
    },
    {
      title: "Early Risers Club",
      src: "/songs/2025-03-30/early_risers_club.mp3",
      duration: 369.504,
    },
  ],
};
export default album;
